import { render, staticRenderFns } from "./ServicesContent.vue?vue&type=template&id=6391219c&scoped=true"
var script = {}
import style0 from "./ServicesContent.vue?vue&type=style&index=0&id=6391219c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6391219c",
  null
  
)

export default component.exports